import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

const BannerLocation = ({ slice }) => {
  const data = useStaticQuery(graphql`
    {
      map: file(relativePath: { eq: "apex-offices-world-map-transparent.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `)
  return (
    <section className='component-banner_location mx-auto max-w-screen-xl p-4'>
      <div className='flex flex-col overflow-hidden rounded bg-gray-800 text-white'>
        <div className='mx-auto flex w-full max-w-7xl flex-wrap py-10 px-8 pb-20'>
          <div className='w-full sm:w-1/2'>
            <h2 className='text-5xl'>{slice.primary.location_title.text}</h2>
            <div className='prose prose-lg mt-10 text-white'>
              <PrismicRichText field={slice.primary.location_text.richText} />
            </div>
          </div>
          <div className='mt-12 w-full sm:mt-0 sm:w-1/2'>
            <GatsbyImage image={data.map.childImageSharp.gatsbyImageData} className='w-full' alt='map of Apex locations around the world' />
          </div>
        </div>
        <footer className='mt-auto bg-gray-600 py-4 pb-8 pt-20 text-center'>
          <div className='relative z-10 -mt-24 flex justify-center lg:-mt-32'>
            {slice.items.map((location, index) => {
              return (
                <div className='mx-1 -mt-2 h-12 w-12 lg:mx-3 lg:mt-1 lg:h-20 lg:w-20' key={`location-${index}`}>
                  <GatsbyImage image={location.location_image.gatsbyImageData} alt={location.location_image.alt} />
                </div>
              )
            })}
          </div>
          <div className='px-4 pt-6'>{slice.primary.location_footer.text}</div>
        </footer>
      </div>
    </section>
  )
}

export default BannerLocation
